module.exports = __webpack_public_path__ + "img/lg_ring_0_0_1_1@3x.65c9ff17.png";